import * as XLSX from "xlsx";

export const DownloadExcel = (title, data) => {
  if (!data) return;

  let finalRows = [];

  if (Array.isArray(data)) {
    // Flat array, just format keys
    finalRows = data.map((row) => {
      const newRow = {};
      Object.keys(row).forEach((key) => {
        const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
        newRow[capitalizedKey] = row[key];
      });
      return newRow;
    });
  } else if (typeof data === "object" && data.metrics) {
    // Complex object: extract rows with environment
    const { metrics } = data;
    for (const env of Object.keys(metrics)) {
      const entries = metrics[env];
      if (Array.isArray(entries)) {
        entries.forEach((entry) => {
          finalRows.push({
            Environment: env,
            Name: entry.name,
            Value: entry.value,
          });
        });
      }
    }
  } else {
    console.warn("Unrecognized data format for Excel export.");
    return;
  }

  if (finalRows.length === 0) return;

  const worksheet = XLSX.utils.json_to_sheet(finalRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const now = new Date();
  const formattedDate = now.toISOString().replace(/[:.]/g, "-");
  const safeTitle = title.replace(/ /g, "_");
  const filename = `${safeTitle}_${formattedDate}.xlsx`;

  XLSX.writeFile(workbook, filename);
};
